import React from "react";
import Header from "../components/header";
import Footer from "../components/footer";
import { useHistory } from "react-router-dom";
const ChangePassword = () =>{
    const history = useHistory()
    document.body.style.backgroundColor = "#F6F6F6"
    return (
        <div>
            <Header whihOne="profile" />
            <section id="section_shop">
            <div className="row col-12">
                        <div className="col-sm-3" id="left_side_profile">
                        <div id="nav_profile">
                            <p id="nav_profile_title" >Setting account</p>
                            <p id="nav_profile_details">
                            You can change or add more infomation
                            </p>
                            <hr  style={{color:"#CCCCCC"}}/>
                            <ul id="profile_nav_ul">
                                <li 
                                 onClick={(()=>{
                                    history.push("/profile")
                                 })}
                                >User Profile</li>
                                <li id="active">Change Password</li>
                            </ul>
                        </div>
                        </div>
                        <div className="col">
                            <div id="right_side_profile_div">
                                <div className="row col-12" id="input_div_profile">
                                    <div className="col-3 mag-A">
                                    <p id="right_side_profile_div_left_name">Password</p>
                                    </div>
                                    <div className="col ">
                                        <div className="row col-12 noMP">
                                            <div className="col">
                                            <input type="password" placeholder="UPassword" id="profile_inputs" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row col-12" id="input_div_profile">
                                    <div className="col-3 mag-A">
                                    <p id="right_side_profile_div_left_name">Re-Password</p>
                                    </div>
                                    <div className="col ">
                                        <div className="row col-12 noMP">
                                            <div className="col">
                                            <input type="password" placeholder="Re-Password" id="profile_inputs" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row col-12" id="input_div_profile">
                                <div className="col ">
                                <button id="button_save_profile">Change Password</button>
                                </div>
                                </div>
                            </div>
                        </div>
            </div>            
            </section>
            <Footer />
        </div>
    )
}
export default ChangePassword;
